// extracted by mini-css-extract-plugin
export var container = "_bu-0";
export var content = "_bu-3";
export var customerTitle = "_bu-4";
export var empty = "_bu-5";
export var gray = "_bu-6";
export var header = "_bu-7";
export var info = "_bu-8";
export var loading = "_bu-2";
export var loadingCard = "_bu-9";
export var oneLine = "_bu-a";
export var personName = "_bu-e";
export var pillContainer = "_bu-b";
export var selected = "_bu-1";
export var text = "_bu-c";
export var twoLines = "_bu-d";
export var unread = "_bu-f";
export var unreadIndicator = "_bu-g";